import { FC } from 'react';
import MuiChip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import { IconX } from '@tabler/icons-react';

import { ChipProps } from './types';

const Chip: FC<ChipProps> = ({
  label,
  color,
  variant,
  size,
  disabled,
  backgroundColor,
  onClick,
  fontSize,
  component,
  hoverColor,
  onDelete,
  shouldStopMouseDownPropagation,
  value,
  startAdornment,
  sx,
  chipRef,
}) => {
  const { palette } = useTheme();
  const gradientBackground =
    variant === 'gradient-blue'
      ? 'linear-gradient(270deg, #BD00FF 5.08%, #3866F5 94.92%)'
      : 'linear-gradient(270deg, #EC4A77 0%, #FF70C6 100%)';
  return (
    <MuiChip
      ref={chipRef}
      icon={startAdornment}
      sx={[
        {
          '& .MuiChip-icon': {
            'marginLeft': '8px',
          },
          '& .MuiChip-deleteIcon': {
            color: palette.colors.grey[700],
            '&:hover': {
              color: palette.colors.grey[800],
            },
          },
          'bgcolor': variant.includes('gradient') ? null : backgroundColor,
          'color': color,
          'borderColor': color,
          'fontSize': fontSize,
        },
        variant === 'intent' && {
          'transition': 'all 150ms ease-in-out 100ms',
          'borderRadius': '20px',
          '&&:hover': {
            'color': hoverColor ? null : backgroundColor,
            'bgcolor': hoverColor ? hoverColor : color,
          },
        },
        (variant === 'intent' || variant === 'outlined') && {
          borderColor: palette.colors.grey[500],
        },
        variant.includes('gradient') && {
          background: gradientBackground,
        },
        ...(Array.isArray(sx) ? sx : [sx ?? {}]),
      ]}
      variant={
        variant === 'intent'
          ? 'outlined'
          : variant === 'gradient-blue' || variant === 'gradient-pink'
            ? 'filled'
            : variant
      }
      onDelete={onDelete ? e => onDelete(e, value ?? label) : undefined}
      onMouseDown={
        onDelete && shouldStopMouseDownPropagation
          ? e => {
              e.stopPropagation();
            }
          : undefined
      }
      deleteIcon={
        <IconX fill={palette.colors.black} size={20} strokeWidth={2} />
      }
      {...{ size, onClick, label, disabled, component }}
    />
  );
};

export default Chip;
